// AdryX — navigation mobile (tiroir, barre de rubriques, bouton retour)
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var body = document.body;
    var burger = document.querySelector('.adryx-burger');
    var overlay = document.querySelector('.adryx-drawer-overlay');
    var closeBtn = document.querySelector('.adryx-drawer-close');

    function openDrawer() {
      body.classList.add('adryx-drawer-open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      body.classList.remove('adryx-drawer-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
    }

    if (burger) {
      burger.addEventListener('click', function (e) {
        e.preventDefault();
        if (body.classList.contains('adryx-drawer-open')) { closeDrawer(); } else { openDrawer(); }
      });
    }
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeDrawer();
    });

    // Rubrique active + recentrage de la barre
    var path = window.location.pathname.replace(/\/$/, '');
    var links = document.querySelectorAll('.adryx-rubriques-scroll a');
    var active = null;
    for (var i = 0; i < links.length; i++) {
      var href = (links[i].getAttribute('href') || '').replace(/\/$/, '');
      if (href && href !== '/collections/all' && path.indexOf(href) === 0) {
        links[i].classList.add('is-active');
        active = links[i];
      }
    }
    if (active && active.parentNode) {
      active.parentNode.scrollLeft = Math.max(0, active.offsetLeft - 20);
    }

    // Bouton retour : historique si on vient du site, sinon lien vers la collection
    var back = document.querySelector('.adryx-back');
    if (back) {
      back.addEventListener('click', function (e) {
        var sameOrigin = document.referrer && document.referrer.indexOf(window.location.origin) === 0;
        if (sameOrigin && window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      });
    }
  });
})();
